import script from "./NewsletterBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsletterBanner.vue?vue&type=script&setup=true&lang=js"

import "./NewsletterBanner.vue?vue&type=style&index=0&id=152b908b&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.44_vue@3.5.44_webpack@5.112.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-152b908b"]])

export default __exports__